module.exports = __webpack_public_path__ + "img/vol05_character_thumb03.632509d1.png";